module.exports = __webpack_public_path__ + "static/img/favlet.5aa4c75.gif";


//////////////////
// WEBPACK FOOTER
// ./static/favlet.gif
// module id = SPwo
// module chunks = 0